<template>
  <v-card flat class="dialog-card">
    <v-toolbar flat light color="white">
      <v-toolbar-title>{{ $t('actions') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="$emit('close')">
        <v-icon>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-divider></v-divider>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <expiration-action-rows :debt="debt"></expiration-action-rows>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
  import ExpirationActionRows from '../Tabs/ExpirationActionRows.vue'

  export default {
    props: ['debt'],
    components: {
      'expiration-action-rows': ExpirationActionRows
    }
  }
</script>
